// extracted by mini-css-extract-plugin
export default {"hero":"ParallaxHero_hero__dzCqO","scene":"ParallaxHero_scene__9J4sH","content":"ParallaxHero_content__kUvmq"};